import { defineStore } from 'pinia'
import requisicao from "@/services/Requisicoes/Get/configuracaoService";

export const useConfiguracoesInteresseStore = defineStore('configuracoesInteresse', {

    state: () => {
        return {
            exibirMensagemErro: false,            
            exibirMensagemSucesso: false,
            exibirVideoImagem: false,
            exibirComponenteInteresse: false,
            configuracoesInteresse: {
                configuracao: {
                    tipoMidia: '',
                    nomeImagemDesktop: '',
                    nomeImagemMobile: '',
                    imagemDesktop: '',
                    imagemMobile: '',
                    linkVideo: '',
                    tipoCorTitulo: null,
                    corTitulo: '',
                    exibeMensagemBoasVindas: null,
                    mensagemBoasVindas: '',
                    unidades: [
                        {
                            codigo: 0,
                            descricao: ''
                        }
                    ]
                }
            }
        }
    },
    actions: {
        async obterConfiguracaoVideoImagem(isMobile) {
            if (this.configuracoesInteresse.configuracao.linkVideo == '' || this.configuracoesInteresse.configuracao.linkVideo == undefined)
                this.configuracoesInteresse.configuracao.linkVideo = ''
            else
                this.configuracoesInteresse.configuracao.linkVideo = this.configuracoesInteresse.configuracao.linkVideo.replace("watch?v=", "embed/") + "?autoplay=1&mute=1&enablejsapi=1"

            if (this.configuracoesInteresse.configuracao.imagemDesktop == '' || this.configuracoesInteresse.configuracao.imagemDesktop == undefined)
                this.configuracoesInteresse.configuracao.imagemDesktop = ''

            if (this.configuracoesInteresse.configuracao.imagemMobile == '' || this.configuracoesInteresse.configuracao.imagemMobile == undefined)
                this.configuracoesInteresse.configuracao.imagemMobile = ''            

            if (
                (this.configuracoesInteresse.configuracao.tipoMidia != "NENHUM") &&
                ((this.configuracoesInteresse.configuracao.linkVideo != '') ||
                 ((!isMobile) && (this.configuracoesInteresse.configuracao.imagemDesktop != '')) ||
                 ((isMobile) && (this.configuracoesInteresse.configuracao.imagemMobile != '')))
            )
                this.exibirVideoImagem = true
        },
        existeUnidadesConfiguradas() {            
            return this.configuracoesInteresse.configuracao.unidades.length > 0
        },
        async obterInformacoes(isMobile) {
            try {
                this.configuracoesInteresse = await requisicao.obterConfiguracaoInicial()
                await this.obterConfiguracaoVideoImagem(isMobile);

                if (this.existeUnidadesConfiguradas()) this.exibirComponenteInteresse = true
                else this.exibirMensagemErro = true                
            } catch {
                this.exibirMensagemErro = true                
            }
        }
    }
})